import { filter, isEmpty, pick } from 'underscore';

const whitelistedSchemaPropertyKeysForModel = [
  'Id',
  'Text',
  'TextPart2',
  'Path1',
  'Path2',
  'FinalUrlSuffix',
  'TrackingUrlTemplate',
  'UrlCustomParameters',
  'Type',
];

export const viewModelToModelForDSA = (adViewModel, campaignId, adGroupId) => ({
  ...pick(adViewModel, whitelistedSchemaPropertyKeysForModel),
  UrlCustomParameters: filter(adViewModel.UrlCustomParameters, ({ Key }) => !isEmpty(Key)),
  Campaign: { Id: campaignId },
  AdGroup: { Id: adGroupId },
});

export const bulkModelToViewModelForDSA = ({
  adModel,
  errors,
}) => ({
  ...pick(adModel, whitelistedSchemaPropertyKeysForModel),
  errors,
});
